<div class="wrapper-md">
    <app-breadcrumbs [items]="[
                 { text: 'bcContestApply_title' }
                     ]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'bcContestApply_title' | translate}}</h1>

        <aside *ngIf="canPickStudent && !isStudentPickerOpened && contest">
            <button type="button" class="btn btn-outline" (click)="toggleStudentPicker()">
                <i class="fi fi-rs-user"></i>
                {{'bcContestApply_btnPickStudent' | translate}}
            </button>
        </aside>
    </header>

    <app-alert level="warning" *ngIf="isReady && !contest">{{'bcContestApply_noContestAvailable' | translate}}</app-alert>

    <app-person-picker *ngIf="isStudentPickerOpened" (pick)="pickStudent($event)"></app-person-picker>

    <ng-container *ngIf="!isStudentPickerOpened">
        <div class="row">
            <div class="data-value col" *ngIf="contest">
                <label>{{'bcContestApply_lblContest' | translate}}</label>
                <div>{{contest.Name}}</div>
            </div>

            <div class="data-value col" *ngIf="canPickStudent && student">
                <label>{{'bcContestApply_lblStudent' | translate}}</label>
                <div>{{student.FullName}} ({{student.Upn}})</div>
            </div>
        </div>

        <app-alert level="warning" *ngIf="isReady && contest && studentData.length == 0">
            {{'bcContestApply_notAvailable' | translate}}
        </app-alert>

        <div class="form-field required" *ngIf="isReady && contest && studentData.length > 1">
            <label class="form-label">{{'bcContestApply_lblSelectProgram' | translate}}</label>
            <app-select [(ngModel)]="student"
                        [options]="studentData"
                        [displayProperty]="'Program'"
                        [required]="true"
                        (selectionChange)="selectStudent($event)"
                        name="student">
            </app-select>
        </div>

        <ng-container *ngIf="isReady && contest && student && !student.HasApplied">
            <app-alert level="info">
                <div [innerHTML]="contest.Description | safeHtml"></div>
            </app-alert>

            <div class="mb-3">
                <app-checkbox [(ngModel)]="hasAgreed" name="hasAgreed">{{'bcContestApply_agree' | translate}}</app-checkbox>
            </div>

            <div class="form-actions">
                <button class="btn btn-primary" type="button" (click)="apply()" [disabled]="!hasAgreed">
                    {{'continue' | translate}}
                </button>
            </div>
        </ng-container>

        <ng-container *ngIf="isReady && contest && student?.HasApplied">
            <app-alert level="info">
                <div>
                    {{'bcContestApply_lblRequiredCreditPoints' | translate}}: <strong>{{student.CreditPoints | number:'1.0-2'}}</strong> ({{requiredEcts | number:'1.0-2'}} ECTS)
                </div>
                <div *ngIf="pointsExtraInfoHtml" [innerHTML]="pointsExtraInfoHtml | safeHtml"></div>
            </app-alert>

            <section class="block">
                <header class="block-header">
                    <h5 [translate]="'bcContestApply_courses' | translate"></h5>
                    <aside *ngIf="contest.IsOpened">
                        <button type="button" class="btn btn-outline-secondary" (click)="editPreferences()">
                            <i class="fi fi-rs-sort-numeric-down"></i>
                            {{'bcContestApply_btnSetPriorities' | translate}}
                        </button>

                        <button type="button" class="btn btn-outline-primary"
                                [routerLink]="['/bc-contests/apply/courses'] | localize"
                                [queryParams]="{ studentId: student.Id, upn: upn }">
                            <i class="fi fi-rs-plus"></i>
                            {{'bcContestApply_btnAddCourses' | translate}}
                        </button>
                    </aside>
                </header>

                <app-bc-contest-course-card *ngFor="let c of courses"
                                            [course]="c"
                                            [studentId]="studentId"
                                            (remove)="onRemove(c)"></app-bc-contest-course-card>
            </section>
        </ng-container>
    </ng-container>
</div>
